exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".selection-body .spacer{margin:0;padding:0;height:0;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/download/views/SelectionListView.css
// module id = 1982
// module chunks = 0